import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { AlertTriangle, Home } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Siden blev ikke fundet - Henneberg Byggeri ApS</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="min-h-[70vh] flex items-center justify-center bg-white text-neutral-900 px-4">
        <div className="max-w-md w-full text-center space-y-6">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 text-amber-600">
            <AlertTriangle className="h-8 w-8" />
          </div>
          <div className="space-y-2">
            <h1 className="text-4xl font-extrabold tracking-tight text-neutral-900 sm:text-5xl">
              404
            </h1>
            <h2 className="text-xl font-bold text-neutral-800">
              Siden blev ikke fundet
            </h2>
            <p className="text-sm text-gray-500 leading-relaxed max-w-sm mx-auto">
              Beklager, men den side du leder efter findes ikke eller er blevet flyttet. Brug menuen eller knappen nedenfor til at komme tilbage.
            </p>
          </div>
          <div>
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded bg-[#434359] px-6 py-3 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-[#343446]"
            >
              <Home className="h-4 w-4" />
              Tilbage til forsiden
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
